// src/pages/departments/EditDepartments.jsx
import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import FormAddEditDepartments from "../../components/Departments/FormAddEditDepartments";
import { useGetDepartmentById } from "../../hooks/Departments/useGetDepartmentById";
import LoadingPage from "../../components/global/LoadingPage";

const EditDepartments = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const { department, isLoading } = useGetDepartmentById(id);

    if (isLoading) return <LoadingPage />;

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditDepartments
                isEdit={true}
                currentData={department}
                onSubmitSuccess={() => navigate("/departments")}
            />
        </WrapperSection>
    );
};

export default EditDepartments;
